import WorkflowActivationPeriodJson from './interfaces/WorkflowActivationPeriodJson'
import { DateTime } from 'luxon'

export default class WorkflowActivationPeriod {
  activeFrom: DateTime
  activeTill: DateTime | null

  constructor(activeFrom: DateTime, activeTill: DateTime | null) {
    this.activeFrom = activeFrom
    this.activeTill = activeTill
  }

  isActive(now: DateTime): boolean {
    return (
      this.activeFrom < now &&
      (this.activeTill === null || this.activeTill > now)
    )
  }

  static fromJson(data: WorkflowActivationPeriodJson) {
    return new this(
      DateTime.fromISO(data.activeFrom.date, {
        zone: data.activeFrom.timezone,
      }),
      data.activeTill
        ? DateTime.fromISO(data.activeTill.date, {
            zone: data.activeTill.timezone,
          })
        : null,
    )
  }
}
